export const ExclusiveContentTab = () => {
  return (
    <>
      <div style={{ position: "relative", paddingBottom: "53.852264%" }}>
        <iframe
          src="https://muse.ai/embed/evbHqMW?search=0&links=0&logo=https://cdn.prod.website-files.com/6356e5735110b93b46145859/6536decbb7ee07856f2dda0d_engineears_logo_white.svg"
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            left: 0,
            top: 0,
          }}
          frameBorder="0"
          allowFullScreen
        />
      </div>
      <div
        style={{
          marginTop: "32px",
          position: "relative",
          paddingBottom: "53.852264%",
        }}
      >
        <iframe
          src="https://muse.ai/embed/yxoaFEj?search=0&links=0&logo=https://cdn.prod.website-files.com/6356e5735110b93b46145859/6536decbb7ee07856f2dda0d_engineears_logo_white.svg"
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            left: 0,
            top: 0,
          }}
          frameBorder="0"
          allowFullScreen
        />
      </div>
    </>
  );
};
